import ImagePopup from '~/components/elements/ImagePopup'
import type { Page_Flexcontent_Flex_Misc } from '~/graphql/types'

export default function Modal({ fields }: { fields: Page_Flexcontent_Flex_Misc }) {
  return <ImagePopup fields={fields} />
}
